module.exports = require('./cartocolor');



//////////////////
// WEBPACK FOOTER
// ./~/cartocolor/index.js
// module id = 27
// module chunks = 6